const NotificationSwitch = ({ label, checked, onToggle }) => (
  <div className="notification-switch-container" style={{ padding: "0px" }}>
    <label className="notification-label">{label}</label>
    <button
      className={`toggle-switch ${checked ? "checked" : ""}`}
      onClick={onToggle}
      aria-pressed={checked}
    >
      <span className="toggle-switch-handle" />
    </button>
  </div>
);

export default NotificationSwitch;
